import { render, staticRenderFns } from "./SelectCard.vue?vue&type=template&id=45b24e56&scoped=true&lang=pug&"
import script from "./SelectCard.vue?vue&type=script&lang=js&"
export * from "./SelectCard.vue?vue&type=script&lang=js&"
import style0 from "./SelectCard.vue?vue&type=style&index=0&id=45b24e56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b24e56",
  null
  
)

export default component.exports